import { BRAND, NAV, SERVICE_AREA } from "@/data/content";
import { Link } from "react-router-dom";
import { useSiteContent, phoneHref } from "@/lib/siteContent";

export default function Footer() {
  const site = useSiteContent();
  const phone = site.contact?.hq_phone || "561.793.9400";
  const email = site.contact?.general_email || "info@rangerconstruction.com";
  const social = Object.entries(site.social_links || {}).filter(([, url]) => url);

  return (
    <footer data-testid="main-footer" className="bg-rc-charcoal text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-24 pb-10">
        <h2 className="font-heading font-black leading-[0.9] tracking-tight text-[clamp(3rem,12vw,11rem)] text-white">
          LET'S BUILD IT<span className="text-rc-red">.</span>
        </h2>

        <div className="mt-16 grid md:grid-cols-4 gap-10 border-t border-white/10 pt-12">
          <div className="md:col-span-2">
            <img src={BRAND.logoLight} alt="Ranger Construction" className="h-16 w-auto mb-5" />
            <p className="text-white/55 max-w-sm text-sm leading-relaxed">{SERVICE_AREA}</p>
          </div>

          <div>
            <div className="font-mono text-rc-sand text-xs uppercase tracking-[0.2em] mb-4">Explore</div>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.key}>
                  <Link to={n.path} className="text-white/70 hover:text-rc-red transition-colors text-sm">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-rc-sand text-xs uppercase tracking-[0.2em] mb-4">Connect</div>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li>
                <a href={phoneHref(phone)} className="hover:text-rc-red transition-colors">{phone}</a>
              </li>
              <li>
                <a href={`mailto:${email}`} className="hover:text-rc-red transition-colors">
                  {email}
                </a>
              </li>
              <li>
                <a
                  href="https://careers.rangerconstruction.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-rc-red transition-colors"
                >
                  Careers
                </a>
              </li>
              {social.map(([name, url]) => (
                <li key={name}>
                  <a href={url} target="_blank" rel="noopener noreferrer" className="hover:text-rc-red transition-colors capitalize">
                    {name === "x" ? "X" : name}
                  </a>
                </li>
              ))}

            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs font-mono">
          <span>© {new Date().getFullYear()} Ranger Construction · All Rights Reserved</span>
          <span className="flex flex-wrap gap-x-3 gap-y-1">
            <span>Asphalt Production · Contracting · Site Preparation</span>
            <Link to="/privacy-terms" className="hover:text-rc-red transition-colors uppercase tracking-[0.18em]">
              Privacy and Terms
            </Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-rc-red transition-colors uppercase tracking-[0.18em]">
              Admin
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
